// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import Register from '../views/Register.vue';
import User from '../views/User.vue';
import Case from '../views/Case.vue';
import Download from '../views/Download.vue';
import Introduction from '../views/Introduction.vue';
import Tutorials from '../views/Tutorials.vue';
import ProductReviews from '../views/ProductReviews.vue';
import Document from '../views/Document.vue'; // 导入 Document 组件
import ForumLayout from '../views/forum/ForumLayout.vue';
import adminRoutes from './admin';  // 导入管理端路由
import store from '../store';

/**
 * 路由配置
 * 包含前台路由和管理端路由
 * 管理端路由放在最后，避免与前台路由冲突
 */
const routes = [
  // 前台路由
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/user',
    name: 'User',
    component: User,
    meta: { requiresAuth: true }
  },
  {
    path: '/case',
    name: 'Case',
    component: Case
  },
  {
    path: '/download',
    name: 'Download',
    component: Download
  },
  {
    path: '/introduction',
    name: 'Introduction',
    component: Introduction
  },
  {
    path: '/tutorials',
    name: 'Tutorials',
    component: Tutorials
  },
  {
    path: '/reviews',
    name: 'ProductReviews',
    component: ProductReviews,
    meta: { title: '产品评价' }
  },
  {
    path: '/forum',
    name: 'Forum',
    component: () => import('@/views/forum/ForumLayout.vue'),
    children: [
      { path: '', name: 'ForumHome', component: () => import('@/views/forum/ReviewList.vue') },
      { path: 'review/:id', name: 'ReviewDetail', component: () => import('@/views/forum/ReviewDetail.vue') },
      { path: 'my', name: 'MyReviews', component: () => import('@/views/forum/MyReviews.vue') },

    ]
  },
  {
    path: '/document',
    name: 'Document',
    component: Document
  },

  // 管理端路由
  ...adminRoutes,  // 使用展开运算符展开管理端路由数组
  // 404页面
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue')
  }
];

// 创建路由实例
const router = createRouter({
  history: createWebHistory(),
  routes
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - 大气校正` : '大气校正'
  
  // 如果是访问管理端登录页面，直接放行
  if (to.path === '/admin/login') {
    next()
    return
  }
  
  // 检查管理端路由
  if (to.path.startsWith('/admin') && to.path !== '/admin/login') {
    const adminToken = localStorage.getItem('adminToken')
    if (!adminToken) {
      next({ path: '/admin/login', query: { redirect: to.fullPath } })
      return
    }
  }
  
  // 检查前台需要登录的路由
  if (to.matched.some(record => record.meta.requiresAuth) && !to.path.startsWith('/admin')) {
    const userToken = localStorage.getItem('token')
    if (!userToken) {
      next({ path: '/login', query: { redirect: to.fullPath } })
      return
    }
  }
  
  next()
});

export default router;

